import { Component, Inject, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject, Subscription } from 'rxjs';
import { filter, takeUntil, withLatestFrom } from 'rxjs/operators';
import { GMB_SERVICE, GMB_STATUS, IGmbService } from '@boxx/gmb-core';
import { OnboardingStore } from '@boxx/onboarding-core';
import { SharingService } from 'src/services/NativeSharing.service';
import { FirebaseAnalyticsService } from 'src/services/NativeFirebase/NativeFirebase.service';
import { ModalController, NavController } from '@ionic/angular';
import { ListContactsPage } from '@app/pages/payment/list-contacts/list-contacts.page';
import { BoxxUtilsService } from 'src/services/BoxxUtils.service';
import { Capacitor } from '@capacitor/core';
import { SocialSharing } from '@ionic-native/social-sharing/ngx';
import { Browser } from '@capacitor/browser';
import { BottomSheetType } from '@app/components/bottom-sheet/bottom-sheet.model';
import { GmbSuccessPage } from '../gmb-success/gmb-success.page';
import { GBPFacade } from '../../state/facades/gbp.facade';
import { BusinessFacade } from '../../state/facades/business.facade';
import { QRService } from 'src/services/qr.service';
import { GoogleAuth } from '@codetrix-studio/capacitor-google-auth';

@Component({
  selector: 'app-gmb-status',
  templateUrl: './gmb-status.page.html',
  styleUrls: ['./gmb-status.page.scss'],
})
export class GmbStatusPage implements OnInit {
  gmbStatus: GMB_STATUS;
  gmbData: any;
  destroyed$ = new Subject<boolean>();
  translations: any;
  logoUrl: string;
  business: any;
  defaultImage: string = 'assets/icon/LateralMenu_ProfileIcon.svg';
  urlGBP: string;
  step = 1;
  subscriptions = new Subscription();

  constructor(
    private storeBusiness: OnboardingStore,
    private translate: TranslateService,
    private sharingService: SharingService,
    private firebaseService: FirebaseAnalyticsService,
    private navCtrl: NavController,
    private boxxUtils: BoxxUtilsService,
    private socialSharing: SocialSharing,
    private modalCtrl: ModalController,
    private qrService: QRService,
    private gbpFacade: GBPFacade,
    private busineesFacade: BusinessFacade,
    @Inject(GMB_SERVICE) private ld3GmbService: IGmbService,
  ) {
    this.translate
      .get(['BUSINESS_FORMS', 'ONBOARDING_MODULE'])
      .pipe(takeUntil(this.destroyed$))
      .subscribe((t) => (this.translations = t));
  }

  ngOnInit() {

    this.subscriptions.add(this.busineesFacade.business$
      .pipe(
        filter(business => business != null)
      ).subscribe((business: any) => {
        this.logoUrl = business.images?.logo_image?.content;
        this.business = business;

        if (business?.config?.hasGmbAccount) {
          this.subscriptions.add(this.gbpFacade.gbp$
            .pipe(
              filter(gbpData => gbpData != null)
            ).subscribe((gbpData: any) => {
              if (gbpData && gbpData !== undefined) {
                console.log('gbpData in page: ', gbpData);
                this.gmbData = gbpData;
                this.urlGBP = gbpData.metadata.mapsUri;
                this.gmbStatus = 'VERIFIED';
              }
              else {
                this.gmbStatus = 'NO_GMB';
              }
            }));

          this.gbpFacade.succeeded$
            .pipe(takeUntil(this.destroyed$))
            .subscribe((fetched) => {
              if (!fetched) {
                this.gbpFacade.loadGBPData();
              }
            });

        } else if (business?.config?.gmbCreateOrSync) {
          this.gmbStatus = 'IN_PROCESS';
        } else {
          this.gmbStatus = 'NO_GMB';
        }
      })
    );

    GoogleAuth.initialize({
      grantOfflineAccess: true
    });

  }

  ionViewDidEnter() {
    this.firebaseService.setScreenName('LISTINGANDCONNECTIONS');
  }

  close() {
    this.navCtrl.back();
  }

  getGmbStatus(gmbStatus: GMB_STATUS) {
    switch (gmbStatus) {
      case 'VERIFIED':
        return this.translations.BUSINESS_FORMS.GMB.verifiedStatus;
      case 'IN_PROCESS':
        return this.translations.BUSINESS_FORMS.GMB.inProgressStatus;
      default:
        return this.translations.BUSINESS_FORMS.GMB.noGmbStatus;
    }
  }

  openBusinessLocation() {
    this.sharingService.openURL(this.gmbData.attributes?.metadata?.mapsUri);
  }

  async openSyncGBP() {

    try {
      const user = await GoogleAuth.signIn();

      if (!user.serverAuthCode) {
        return;
      }
      this.boxxUtils.handleLoading(true);

      let locations: any;
      try {
        locations = await this.ld3GmbService
          .setAuthCode({
            code: user.serverAuthCode,
            redirect:
              window.location.origin === 'capacitor://localhost'
                ? 'http://localhost'
                : window.location.origin,
          })
          .toPromise();

        console.log('Autenticación exitosa:', locations);
      } catch (error) {
        console.error('Error al autenticar:', error);
      } finally {
        this.boxxUtils.handleLoading(false);
      }

      //nuevo
      let _customData = [];
      for (let i = 0; i < locations.length; i++) {
        console.log('categories: ', locations[i].categories);
        console.log('storefrontAddress: ', locations[i].storefrontAddress);
        console.log('phones: ', locations[i].phoneNumbers);
        _customData.push({
          id: locations[i].storeCode,
          name: locations[i].title,
          category: locations[i].categories?.primaryCategory?.displayName || '',
          address: locations[i].storefrontAddress ? this.formatAddress(locations[i].storefrontAddress) : '',
          phone: locations[i].phoneNumbers?.primaryPhone || ''
        });
      }

      console.log('_customData: ', _customData);

      this.boxxUtils.openBottomSheet({
        data: _customData,
        type: BottomSheetType.gbp_options,
        initialBreakpoint: 1,
        breakpoints: [0, 1],
        canClose: true,
        hasSearchBar: false,
        hasFooter: true,
        searchText: '',
        title: 'ONBOARDING_MODULE.GMB_SURVEY.GBP.DETAIL.selectBusiness',
        maxHeigth: 90
      }).then(async (data) => {
        console.log('data modal: ', data)
        if (data?.value) {


          //const data: any = await this.selectLocationModal(locations);
          const selectedLocation = locations.find((item) => item.storeCode === data?.value);
          console.log('location selected: ', selectedLocation)

          await this.boxxUtils.handleLoading(true);
          const respData = await this.ld3GmbService.setSelectedLocation(selectedLocation).toPromise();
          if (respData) {
            this.gbpFacade.loadGBPData();
            this.gmbStatus = 'VERIFIED';
            const view = await this.modalCtrl.create({
              component: GmbSuccessPage,
            });

            await view.present();

            this.step === 2;
            setTimeout(() => {
              this.boxxUtils.handleLoading(false);
            }, 2000);
          }

          // console.log('data?.value: ', data?.value)
          // return data.value;
        }
        else {
          this.boxxUtils.handleLoading(false);
        }
      });

      //end nuevo



    } catch (error) {
      console.error('Error durante el inicio de sesión con Google: ', error);
    }

  }

  formatAddress(address: any): string {
    if (!address || typeof address !== 'object') return '';

    const street = address.addressLines?.filter(line => line?.trim()).join(', ') || '';
    const locality = address.locality || '';
    const state = address.administrativeArea || '';
    const countryCode = address.regionCode?.toUpperCase() || '';

    let country = '';
    if (countryCode === 'MX') {
      country = 'México';
    } else if (countryCode === 'US' || countryCode === 'USA') {
      country = 'United States';
    }

    // Armar dirección
    const parts = [street, locality, state, country].filter(Boolean);
    return parts.join(', ');
  }

  async selectLocationModal(locations: any[]) {
    let _customData = [];
    for (let i = 0; i < locations.length; i++) {
      console.log('categories: ', locations[i].categories);
      console.log('storefrontAddress: ', locations[i].storefrontAddress);
      console.log('phones: ', locations[i].phoneNumbers);
      _customData.push({
        id: locations[i].storeCode,
        name: locations[i].title,
        category: locations[i].categories?.primaryCategory?.displayName || '',
        address: locations[i].storefrontAddress ? this.formatAddress(locations[i].storefrontAddress) : '',
        phone: locations[i].phoneNumbers?.primaryPhone || ''
      });
    }

    console.log('_customData: ', _customData);

    this.boxxUtils.openBottomSheet({
      data: _customData,
      type: BottomSheetType.gbp_options,
      initialBreakpoint: 1,
      breakpoints: [0, 1],
      canClose: true,
      hasSearchBar: false,
      hasFooter: true,
      searchText: '',
      title: 'ONBOARDING_MODULE.GMB_SURVEY.GBP.DETAIL.selectBusiness',
      maxHeigth: 90
    }).then((data) => {
      console.log('data modal: ', data)
      if (data?.value) {
        console.log('data?.value: ', data?.value)
        return data.value;
      }
      else {
        return null;
      }
    });
  }


  async shareUrl(url: string) {
    const platform = Capacitor.getPlatform();
    if (platform === 'android' || platform === 'ios') {
      try {
        this.socialSharing.share('Google Business Profile', 'Google Business Profile', this.urlGBP, url)
          .then(() => { }).catch((error) => { });

        // await Share.share({
        //   title: 'Google Business Profile',
        //   text: this.urlGBP,
        //   dialogTitle: this.translations.ONBOARDING_MODULE.GMB_SURVEY.GBP.shared_alert,
        // });
      } catch (error) { }
      return;
    }

    const view = await this.modalCtrl.create({
      component: ListContactsPage,
    });

    await view.present();

    const { data } = await view.onWillDismiss();

    if (data && data.contact.phone) {

      if (data.contact.phone.length !== 10) {
        this.boxxUtils.showAlert({
          header: this.translations.ACTIONS.confirm,
          message: this.translations.CONTACTS_MODULE.confirmUpdateContactPhoneMsg,
          buttons: [
            {
              text: this.translations.ACTIONS.cancel,
              role: 'cancel',
            },
            {
              text: this.translations.ACTIONS.ok,
            },
          ],
        });
        return;
      }

      let code: string;
      switch (data.contact.countryCode) {
        case 'MEX':
          code = `${data.contact.phoneCode}1`;
          break;
        case 'ARG':
          code = `${data.contact.phoneCode}9`;
          break;
        default:
          code = data.contact.phoneCode;
      }
      this.sharingService.openURL(
        `https://wa.me/${code}${data.contact.phone}?text=${encodeURIComponent(
          this.urlGBP
        )}`
      );
    }
  }

  openQR() {
    let _sites = [
      {
        key: 'gbp',
        value: 'TABS.qr.option_website',
        icon: 'QR_web',
        icon_type: 'src',
        class: 'custom',
        url: this.urlGBP
      }
    ];

    this.boxxUtils.openBottomSheet({
      data: [],
      site: _sites,
      firstTimeOpen: true,
      type: BottomSheetType.qr,
      initialBreakpoint: 1,
      breakpoints: [0, 1],
      canClose: true,
      title: '',
      maxHeigth: 80
    }).then((data: any) => {
      if (data?.value) {
        console.log('data: ', data)
        this.qrService.actionsSiteSelected(data?.value, data?.url);
      }
    });

  }

  async viewProfile() {
    //window.open(this.urlGBP, '_blank');
    await Browser.open({ url: this.urlGBP });
  }

  finish() {
    this.navCtrl.back();
  }
}
